import { useEffect, useState } from 'react';
import { useParams, useLocation, Link } from 'react-router-dom';
import Loader from 'src/components/loader';
import RegisterUsersModal from '../registerUsersModal';
import {
    uploadEmailsToMemberList,
    getEmailsFromMemberList,
    setupCourseRegistrationFlow,
    getMemberList
} from '../../../utilities/courseRegistrationService';

const CourseRegistrations: React.FC = () => {
    const { id: courseId } = useParams<{ id: string }>();
    const location = useLocation();
    const { courseName, channelId } = (location.state as any) || {};

    const [registrations, setRegistrations] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [memberListId, setMemberListId] = useState<number | null>(null);

    useEffect(() => {
        const fetchRegistrations = async () => {
            try {
                setLoading(true);

                if (!courseName || !channelId) {
                    console.error('Missing courseName or channelId');
                    setRegistrations([]);
                    return;
                }

                // Step 1: Check if member list already exists
                const listRes = await getMemberList(courseName);

                let listId: number;

                if (listRes.result && listRes.result.length > 0) {
                    //  Already exists → reuse
                    listId = listRes.result[0].id;
                    console.log('Using existing member list:', listId);
                } else {
                    //  Not found → run full setup flow
                    const { memberListId } = await setupCourseRegistrationFlow(courseName, channelId);
                    listId = memberListId;
                    console.log('Created new member list:', listId);
                }

                setMemberListId(listId);

                // Step 2: Fetch emails for that list
                const emailRes = await getEmailsFromMemberList(listId);
                const result = emailRes.result || {};
                const regs: any[] = [];
                Object.values(result).forEach((val) => {
                    const emails = (val as string).split(',');
                    emails.forEach((email) =>
                        regs.push({ email: email.trim(), date: new Date().toISOString() })
                    );
                });

                setRegistrations(regs);
            } catch (err) {
                console.error('Error fetching registrations:', err);
                setRegistrations([]);
            } finally {
                setLoading(false);
            }
        };

        fetchRegistrations();
    }, [courseName, channelId]);

    console.log(memberListId);
    return (
        <div className="p-6">
            <Link to={`/courseTab/${courseId}`}>
                <i className="fas fa-arrow-left mt-2 mb-2"></i>
                <span className="ml-2">Go Back</span>
            </Link>
            <h2 className="text-xl font-semibold mb-4">
                Course Registrations {courseName ? `– ${courseName}` : ''}
            </h2>

            <button onClick={() => setShowModal(true)} className="btn-primary mb-4 w-64 ml-0">
                Register a User
            </button>

            {loading ? (
                <Loader />
            ) : registrations.length === 0 ? (
                <p>No registrations found.</p>
            ) : (
                <table className="table-auto w-full border">
                    <thead>
                        <tr>
                            <th className="p-2 text-left">Email</th>
                            <th className="p-2 text-left">Registered Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {registrations.map((reg, idx) => (
                            <tr key={idx}>
                                <td className="p-2">{reg.email}</td>
                                <td className="p-2">{ }</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}

            <RegisterUsersModal
                show={showModal}
                onClose={() => setShowModal(false)}
                onRegister={async (emails, file) => {
                    if (!memberListId) {
                        console.error('No memberListId found for this course');
                        return;
                    }

                    try {
                        // 1. Save emails via API
                        await uploadEmailsToMemberList(memberListId, emails);

                        // 2. Refresh registrations list
                        const emailRes = await getEmailsFromMemberList(memberListId);
                        const result = emailRes.result || {};
                        const regs: any[] = [];
                        Object.values(result).forEach((val) => {
                            const ems = (val as string).split(',');
                            ems.forEach((email) =>
                                regs.push({ email: email.trim(), date: new Date().toISOString() })
                            );
                        });
                        setRegistrations(regs);
                    } catch (err) {
                        console.error('Error uploading emails:', err);
                    } finally {
                        setShowModal(false);
                    }
                }}
            />
        </div>
    );
};

export default CourseRegistrations;
